import * as Money from './components/Money.css';

export default {
	Money
};
